import { render, staticRenderFns } from "./PanelSession.vue?vue&type=template&id=c70b2fe4&"
import script from "./PanelSession.vue?vue&type=script&lang=js&"
export * from "./PanelSession.vue?vue&type=script&lang=js&"
import style0 from "./PanelSession.vue?vue&type=style&index=0&id=c70b2fe4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c70b2fe4')) {
      api.createRecord('c70b2fe4', component.options)
    } else {
      api.reload('c70b2fe4', component.options)
    }
    module.hot.accept("./PanelSession.vue?vue&type=template&id=c70b2fe4&", function () {
      api.rerender('c70b2fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/PanelSession.vue"
export default component.exports